<template>
  <div>
    <section
      v-if="consultVisible && (!consultConnection || consultError)"
      class="online-consult-panel"
      aria-label="在线咨询"
    >
      <div class="online-consult-panel__header">
        <div>
          <strong>在线咨询</strong>
          <span>客服回复将显示在这里</span>
        </div>
        <a-button type="link" size="small" title="收起咨询窗口" @click="closeOnlineConsult">
          <a-icon type="minus" /> 收起
        </a-button>
      </div>
      <div v-if="consultError" class="online-consult-panel__status" role="alert">
        <a-icon type="customer-service" />
        <h2>在线咨询暂时无法打开</h2>
        <p>{{ consultError }}</p>
        <a-button type="primary" @click="openOnlineConsult">重新连接</a-button>
      </div>
      <div v-else class="online-consult-panel__status" role="status">
        <a-spin size="large" />
        <h2>正在连接客服</h2>
        <p>正在为您建立安全会话，请稍候。</p>
      </div>
    </section>
    <OnlineConsult v-if="consultVisible && consultConnection && !consultError"
      :connection="consultConnection" @minimize="closeOnlineConsult"
      @session-ready="onConsultReady" @session-error="onConsultError"
    />
    <!-- header -->
    <div v-if="!($route.path == '/index' && !store.getters.getConfig.is_header)">
      <Header></Header>
      <div v-if="showCustomerService" :class="show ? 'side-bar show' : 'side-bar'">
        <div class="side-button">
          <a-button type="primary" @click="showDrawer" class="model-button"
            ><div class="flex flex-col">
              <a-badge :dot="consultUnread > 0"><span class="button-text">在线客服</span></a-badge>
              <a-icon :type="barvisible ? 'double-right' : 'double-left'" /></div
          ></a-button>

          <!-- <Drawer
        :visible="false"
        :closable="false"
        :height="666"
        placement="right"
        @close="close = false"
        class="button-drawer"
        :mask="false"
      >
  
      </Drawer> -->
        </div>

        <div class="side-right">
          <div class="side-header"
            ><img src="@/assets/images/headset.png" class="w-5 h-5 mr-2 ml-9" />在线客服
            <a-icon type="close" class="ml-7" @click="showDrawer" :style="{ fontSize: '13px' }"
          /></div>
          <div class="flex flex-col items-center justify-items-center">
            <a-badge :dot="consultUnread > 0" class="online-consult-entry">
              <a-button type="primary" block :loading="consultLoading" @click="openOnlineConsult"
                :aria-label="consultUnread > 0 ? '在线咨询，有未读客服回复' : '在线咨询'">
                在线咨询
              </a-button>
            </a-badge>
            <h6>技术服务电话</h6>
            <p>{{ store.getters.getConfig.tel }}</p>
            <h6>工作时间</h6>
            <p>周一至周五（9:00-17:00)</p>
            <h6>扫一扫联系我们</h6></div
          >
          <div
            ><img
              :src="$ossUrl + store.getters.getConfig.miniapp_qrcode"
              :style="{ width: '120px' }"
              class="ml-10"
          /></div>
          <div class="side-foot"
            ><a-icon type="to-top" :style="{ fontSize: '20px' }" @click="toTop"
          /></div>
        </div>
      </div>

      <div class="h-16"></div>
      <!-- body -->
      <div style="min-height: calc(100vh - 200px)">
        <transition name="page-transition">
          <route-view />
        </transition>
      </div>
      <!-- footer -->
      <Footer></Footer>
    </div>
    
    <div v-if="($route.path == '/index' && !store.getters.getConfig.is_header)">
      <transition name="page-transition">
          <route-view />
        </transition>
    </div>
  </div>
</template>

<script>
  import OnlineConsult from '@/components/OnlineConsult/index.vue';
  import Header from './content/header.vue';
  import Footer from './content/footer.vue';
  import RouteView from './RouteView';
  import store from '@/store/index';
  import { mapGetters } from 'vuex';
  import { openOnlineConsult, startUnreadMonitor } from '@/utils/online-consult';
  export default {
    name: 'BasicLayout',
    components: { Header, Footer, RouteView, OnlineConsult },
    data() {
      return {
        // 在线客服入口总开关：false = 隐藏全部客服按钮与面板
        showCustomerService: true,
        consultLoading: false,
        consultVisible: false,
        consultConnection: null,
        consultFrameReady: false,
        consultError: '',
        consultGeneration: 0,
        consultUnread: 0,
        collapsed: false,
        menus: [],
        barvisible: false,
        show: false,
        store: store,

      };
    },
    computed: {
      contentPaddingLeft() {
        if (!this.fixSidebar || this.isMobile()) {
          return '0';
        }
        if (this.sidebarOpened) {
          return '180px';
        }
        return '80px';
      },
      ...mapGetters(['getToken']),
    },
    watch: {
      getToken() { this.resetConsultMonitor(); },
    },
    beforeDestroy() {
      if (this.consultMonitor) this.consultMonitor.stop();
      window.removeEventListener('storage', this.onConsultStorage);
      this.closeOnlineConsult();
    },
    created() {},
    mounted() {
      this.resetConsultMonitor();
      window.addEventListener('storage', this.onConsultStorage);

      if (this.getToken) {
        this.$store.dispatch('user/getUserInfoAction');
      }
      console.log(this.$route.path);
    },
    methods: {
      onConsultStorage(event) {
        if (event.key === 'token' || event.key === null) this.resetConsultMonitor();
      },
      resetConsultMonitor() {
        this.closeOnlineConsult();
        if (this.consultMonitor) this.consultMonitor.stop();
        this.consultUnread = 0;
        this.consultMonitor = startUnreadMonitor(
          (count) => { this.consultUnread = count; },
          () => { this.barvisible = true; this.show = true; },
        );
      },
      closeOnlineConsult() {
        this.consultGeneration++;
        clearTimeout(this.consultFrameTimer);
        this.consultVisible = false;
        this.consultConnection = null;
        this.consultLoading = false;
        this.consultFrameReady = false;
        this.consultError = '';
      },
      onConsultReady() {
        clearTimeout(this.consultFrameTimer);
        this.consultFrameReady = true;
      },
      onConsultError() {
        clearTimeout(this.consultFrameTimer);
        this.consultError = '客服连接失败，请重新连接。';
        this.consultConnection = null;
      },
      async openOnlineConsult() {
        if (this.consultLoading) return;
        clearTimeout(this.consultFrameTimer);
        const generation = ++this.consultGeneration;
        this.consultVisible = true;
        this.barvisible = false;
        this.show = false;
        this.consultConnection = null;
        this.consultError = '';
        this.consultFrameReady = false;
        this.consultLoading = true;
        try {
          const connection = await openOnlineConsult();
          if (generation !== this.consultGeneration) return;
          this.consultConnection = connection;
          this.consultFrameTimer = setTimeout(() => {
            if (generation !== this.consultGeneration || this.consultFrameReady) return;
            this.consultError = '客服连接超时，请重新连接。';
            this.consultConnection = null;
          }, 20000);
        } catch (error) {
          if (generation === this.consultGeneration) {
            this.consultError = error.message || '在线咨询暂时无法打开，请稍后重试。';
          }
        } finally {
          if (generation === this.consultGeneration) this.consultLoading = false;
        }
      },
      toTop() {
        document.documentElement.scrollTop = 0;
      },
      afterVisibleChange(val) {
        console.log('visible', val);
      },
      showDrawer() {
        if (this.barvisible == true) {
          this.barvisible = false;
          this.show = false;
        } else {
          this.barvisible = true;
          this.show = true;
        }
      },
      onClose() {
        this.barvisible = false;
        this.show = false;
      },
    },
  };
</script>

<style lang="less">
  /*
  * The following styles are auto-applied to elements with
  * transition="page-transition" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the page transition by editing
  * these styles.
  */

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .online-consult-panel {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 1001;
    display: flex;
    width: 420px;
    height: min(680px, calc(100vh - 48px));
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #dfe7f0;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 12px 36px rgba(30, 53, 80, .22);
    color: #34465c;
  }
  .online-consult-panel__header {
    display: flex;
    min-height: 56px;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px 0 18px;
    border-bottom: 1px solid rgba(255, 255, 255, .18);
    background: #415695;
    color: #fff;
  }
  .online-consult-panel__header strong { display: block; font-size: 17px; }
  .online-consult-panel__header span {
    display: block;
    margin-top: 2px;
    color: rgba(255, 255, 255, .72);
    font-size: 12px;
  }
  .online-consult-panel__header .ant-btn { color: #fff; }
  .online-consult-panel__status {
    display: flex;
    min-height: 0;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    text-align: center;
  }
  .online-consult-panel__status > .anticon:not(.anticon-loading) {
    color: #415695;
    font-size: 42px;
  }
  .online-consult-panel__status h2 {
    margin: 16px 0 8px;
    color: #21364e;
    font-size: 19px;
  }
  .online-consult-panel__status p {
    max-width: 310px;
    margin: 0 0 20px;
    color: #76869a;
    font-size: 13px;
    line-height: 1.7;
  }
  .online-consult-entry {
    width: calc(100% - 24px);
    margin: 8px 12px;
  }
  .model-button {
    border-color: #415695 !important;
    background-color: #415695 !important;
    height: 120px !important;
    width: 40px !important;
  }
  .side-button {
    margin-top: 150px;
  }
  .button-text {
    padding-right: 50px;
    font-weight: 700;
    line-height: 21px;
    white-space: normal;
    width: 40px;
    padding-bottom: 2px;
  }
  .button-drawer {
    height: 500px !important;
  }

  .side-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 180px;
    height: 400px;
    border: 1px solid #34478f;
    background: white;
    // background-color: #34478f;
  }

  .side-bar {
    display: flex;
    height: 500px;
    position: fixed;
    z-index: 1000;
    right: -183px;
    top: 35vh;
    transition: right 0.5s;
  }

  .show {
    right: 0px;
  }

  .side-header {
    display: flex;

    align-items: center;
    height: 35px;
    background: #34478f;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }

  .side-foot {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    background: #34478f;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }
  @media (max-width: 640px) {
    .online-consult-panel {
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      border: 0;
      border-radius: 0;
    }
  }
</style>
